module.exports = __webpack_public_path__ + "static/media/ClassicAdvancedOrgChartCardImage.d5f99ddb.png";